import * as React from 'react';
import {observer} from 'mobx-react';
import {useNavigate} from 'react-router-dom';
import {Box, useTheme} from '@mui/material';
import {useApplication} from '../../../ApplicationProvider';
import {useNavigatorFeature} from '../../../useFeature';
import LayoutContentWrapper from '../../../components/layout/LayoutContentWrapper';
import LayoutContentTitle from '../../../components/layout/LayoutContentTitle';
import FilledButton from '../../../components/buttons/FilledButton';
import CreateAllowanceFeature from './CreateAllowanceFeature';
import AllowanceScreen from '../AllowanceScreen';
import {styles} from './CreateAllowanceStyles';

function CreateAllowanceScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const theme = useTheme();
    const feature = useNavigatorFeature(
        () => new CreateAllowanceFeature(application, navigator),
        navigator
    );
    const style = styles(theme);
    const isFeatureReady = feature && feature.loaded;

    const content = () => {
        const newAllowance = feature.newAllowance;
        return (
            <Box sx={style.container}>
                <LayoutContentTitle title="Crear Bonificación"/>
                <AllowanceScreen allowance={newAllowance}/>
                <Box sx={style.buttonsContainer}>
                    <FilledButton
                        disabled={!newAllowance.isValid}
                        onClick={() => feature.submitAllowance()}
                    >
                        Crear Bonificación
                    </FilledButton>
                </Box>
            </Box>
        );
    };

    return (
        <LayoutContentWrapper
            isLoading={!isFeatureReady}
            renderContent={() => content()}
        />
    );
}

export default observer(CreateAllowanceScreen);
